var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('PageBack'),_c('PageHeader',{attrs:{"title":_vm.$t('recom_promocode-create.title')}}),_c('Form',{ref:"form",attrs:{"init-on-success":true,"fields":_vm.fields,"model":_vm.defaultValues,"action":_vm.createRecomPromotionCode},on:{"success":function($event){return _vm.$router.push({name: 'recom-promo-codes'})}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }